export default __webpack_public_path__ + "static/media/open_san.a192808a.woff2";